/* unplugin-vue-components disabled */var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-bottom-sheet",
    {
      attrs: { "hide-overlay": "" },
      model: {
        value: _vm.isView,
        callback: function ($$v) {
          _vm.isView = $$v
        },
        expression: "isView",
      },
    },
    [
      _c(
        "v-sheet",
        { staticClass: "text-center pb-3", attrs: { color: "dark", dark: "" } },
        [
          _c("div", { staticClass: "py-3" }, [
            _vm._v(
              "\n      Usamos cookies para garantir que você tenha a melhor experiência em\n      nosso site\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                top: "",
                title: "aceitar todos os cookies",
                color: "success",
                small: "",
                dark: "",
                depressed: "",
              },
              on: {
                click: function ($event) {
                  return _vm.accept()
                },
              },
            },
            [_vm._v("\n      Aceitar\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }